import { Toaster } from "react-hot-toast"
import { useIntl } from "@contexts/intl/Internationalization"
import themeConfig from "@configs/themeConfig"

/**
 * Toast position follows reading direction: RTL → top-left, LTR → top-right.
 */
const ToastHost = () => {
  const { locale } = useIntl()
  const position =
    locale === "ar" ? "top-left" : themeConfig.layout.toastPosition || "top-right"

  return (
    <Toaster
      position={position}
      toastOptions={{ className: "react-hot-toast" }}
    />
  )
}

export default ToastHost
